// ProjectCard.js
import React from "react";

const ProjectCard = ({ imgUrl, title, onClick }) => {
    return (
        <div className="skill-card" onClick={onClick}>
            {/* Card Header */}
            <div className="card-header">
                {/* Optionally add a level bar or other metadata if relevant */}
            </div>

            {/* Icon/Image Section */}
            <div className="icon-section">
                <div className="icon-container">
                    <div className="icon-backdrop"></div>
                    <div className="icon-wrapper">
                        <img src={imgUrl} alt={title} className="skill-icon" />
                    </div>
                    <div className="icon-glow"></div>
                </div>
            </div>

            {/* Card Footer */}
            <div className="card-footer">
                <h3 className="skill-name">{title}</h3>
                {/* Optionally add progress dots or other indicators if desired */}
            </div>

            {/* Hover Effects */}
            <div className="card-overlay"></div>
            <div className="scan-line"></div>
        </div>
    );
};

export default ProjectCard;